(function () {
  'use strict';

  function fmt(n) {
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    return String(n);
  }


  function initSocialCount(swat) {
    var wraps = document.querySelectorAll('[data-swym-count-wrap]');
    if (!wraps.length || !swat.wishlist || !swat.wishlist.getSocialCount) return;

    wraps.forEach(function (wrap) {
      var empi = wrap.getAttribute('data-product-id');
      swat.wishlist.getSocialCount(
        { empi: empi },
        function (res) {
          var count = res && res.data ? res.data.count : res && res.count;
          count = parseInt(count, 10) || 0;
          if (count > 1) {
            wrap.querySelector('[data-swym-count-value]').textContent = fmt(count);
            wrap.hidden = false;
          } else {
            wrap.hidden = true;
          }
        },
        function (err) {
         // console.log('Swym social count error', err);
        }
      );
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initSocialCount);
})();